import { Navigate } from 'react-router-dom';

import { useAuthContext } from '../../contexts/authContext';

const Root = () => {
  const { isAuthenticated, role } = useAuthContext();

  if (isAuthenticated) {
    return role === 'ADMIN' ? (
      <Navigate to="/admin" replace />
    ) : (
      <Navigate to="/projects" replace />
    );
  }

  return <Navigate to="/home" replace />;
};

export default Root;
